"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorRenewalEditCarExcessWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../../../../components/modals/InfoModal");
var Types_1 = require("../../../../../Types");
var core_1 = require("@athena-portal/core");
var ExcessExplainedRenderers_1 = require("../../../../../components/modals/renderers/ExcessExplainedRenderers");
var VehicleExcessPickerWidget_1 = require("../../../../../components/annual/motor/VehicleExcessPickerWidget");
var portal_core_1 = require("@ferry/portal-core");
var AnnualMotorRenewalEditCarExcessWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorRenewalEditCarExcessWidget, _super);
    function AnnualMotorRenewalEditCarExcessWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectOnChangeEvent = function (event) {
            var voluntaryExcess = parseInt(event.target.value, 10);
            var totalExcess = _this.state.compulsoryExcess + voluntaryExcess;
            _this.setState({
                voluntaryExcess: voluntaryExcess,
                totalExcess: totalExcess
            });
            _this.props.onStateChange("vehicles[0].annualVehicleExcess.voluntaryExcess", voluntaryExcess);
            _this.executeNativeEvent(event);
        };
        var compulsoryExcess = _this.props.interaction.vehicles[0].annualVehicleExcess.compulsoryExcess;
        var voluntaryExcess = _this.props.interaction.vehicles[0].annualVehicleExcess.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        _this.state = {
            showPopup: false,
            compulsoryExcess: compulsoryExcess,
            voluntaryExcess: voluntaryExcess,
            initialVoluntaryExcess: voluntaryExcess,
            totalExcess: totalExcess
        };
        _this.togglePopUp = _this.togglePopUp.bind(_this);
        return _this;
    }
    AnnualMotorRenewalEditCarExcessWidget.prototype.render = function () {
        var vehicle = this.props.interaction.vehicles[0];
        return ((0, jsx_runtime_1.jsx)("div", { className: "car-panel-widget", children: (0, jsx_runtime_1.jsxs)("div", { className: "edit-car-excess-widget ".concat(this.getSetting("cssClass", ""), " panel"), children: [(0, jsx_runtime_1.jsx)("div", { className: "edit-car-excess-img", children: (0, jsx_runtime_1.jsx)("img", { className: "excess-img", alt: "excess-icon", "aria-hidden": "true", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/excess-icon.svg") }) }), (0, jsx_runtime_1.jsx)("div", { className: "edit-car-excess-content", children: (0, jsx_runtime_1.jsxs)("div", { className: "detail excess-detail", children: [(0, jsx_runtime_1.jsxs)("h2", { className: "detail-key excess-heading d-flex", children: ["Excesses that apply", (0, jsx_runtime_1.jsx)(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Excess explained", showArrow: false, children: (0, ExcessExplainedRenderers_1.renderExcessExplained)(vehicle.annualVehicleExcess) })] }), (0, jsx_runtime_1.jsx)("p", { className: "select-excess", children: "Please select your voluntary excess below." }), (0, jsx_runtime_1.jsx)(VehicleExcessPickerWidget_1.VehicleExcessPickerWidget, { compulsoryExcess: vehicle.annualVehicleExcess.compulsoryExcess, voluntaryExcess: vehicle.annualVehicleExcess.voluntaryExcess, vehicle: vehicle, questionName: this.props.question.name, onSelectOnChangeEvent: this.handleSelectOnChangeEvent, onFocusOrClickEvent: this.executeNativeEvent })] }) })] }) }));
    };
    AnnualMotorRenewalEditCarExcessWidget.prototype.togglePopUp = function () {
        this.setState(function (state) { return ({
            showPopup: !state.showPopup
        }); });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], AnnualMotorRenewalEditCarExcessWidget.prototype, "changelogRecorder", void 0);
    return AnnualMotorRenewalEditCarExcessWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorRenewalEditCarExcessWidget = AnnualMotorRenewalEditCarExcessWidget;
//# sourceMappingURL=AnnualMotorRenewalEditCarExcessWidget.js.map